function ltrim(str, characters) {
  if (typeof str !== "string") {
    console.error(
      "First parameters need to be a string, you gave: ",
      typeof str,
    );
    return str;
  }

  // If no characters are provided, default to PHP's whitespace mask
  if (!characters) {
    return str.trimStart();
  }

  // Escape special regex characters in the mask
  const escapedChars = characters.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

  // Create a regex to match the characters at the start of the string
  const regex = new RegExp(`^[${escapedChars}]+`);

  return str.replace(regex, "");
}
export default ltrim;
